module.exports = __webpack_public_path__ + "img/Corona_So_schuetzen_wir_uns_Logo.png";